<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UUip7W/tc-custom/9781398420465.jpg?1705540958202" alt="This image is the cover for the book The Jackdaw Detail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Jackdaw Detail
      </h1>
      <p class="bookDescription body article font2">
        <p>Peru, 2005. The towering mountains and deep, forested valleys of La Convención Province provide sanctuary for a dangerous criminal organisation with sufficient military capability to challenge government forces. An elite unit of British SAS are tasked to implement a solution. Their ground-breaking new equipment offers a decisive advantage and enables an unorthodox covert approach, but its untested nature also brings complications. Soon the British team find themselves ensnared in a web of corruption and conflicting interest, where the only way forward is to elevate the crisis to a chaotic conclusion. The Jackdaw Detail weaves between political, tactical and financial motives, as soldiers and civilians alike are drawn into an ever-thickening plot.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ryan M Love
      </h2>
      
      <p class="authorDescription body article">Ryan M Love was born in Kent. Following an education in horticulture, he worked principally as a gardener until a keen interest in modern military history inspired him to begin writing fiction. Having a passion for the outdoor life, he is an avid mountain biker, snowboarder and trail runner. He currently lives in Wales, just outside the Brecon Beacons National Park.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c645b86